import { useState } from 'react'


export const TextInputEditor = (props) => {
    const [value, setValue] = useState(props.value);

    const handleChange = (e) => {
        setValue(e.target.value);
        props.colDef.cellEditorParams.handleCellChange(props.node.data, props.colDef.field, e.target.value);
    };

    return <textarea rows={5} value={value} onChange={handleChange} />;
};
